<template>
    <base-form
        ref="form"
        v-model="form"
        :api="apiClientType.RESIDENTIAL_CANTEEN_ADDRESSES"
        :mapper="mapperType.RESIDENTIAL_CANTEEN_ADDRESSES_FORM"
        :entity-id="entityId"
        :title="title"
        :disabled="disabled"
        @created="created($event)"
        @updated="updated($event)"
        @cancelled="cancelled"
        @deleted="deleted"
    >
        <!-- RESIDENTIAL CANTEEN ADDRESSES -->

        <v-col cols="12">
            <v-card color="grey lighten-5" flat>
                <v-card-title primary-title>
                    <h3 class="headline">
                        {{ $t('residential_canteen_address.details') }}
                    </h3>
                </v-card-title>
                <v-card-text>
                    <div class="row">
                        <div class="col-lg-12">
                            <!-- residential canteen address name -->
                            <text-input
                                v-model="form.name"
                                v-validate="'required|min:1|max:100|space'"
                                name="name"
                                label="residential_canteen_address.name"
                                :error-messages="errors.collect('name')"
                                :data-vv-as="
                                    $t('residential_canteen_address.name')
                                "
                            ></text-input>

                            <!-- residential canteen address phone -->
                            <text-input
                                v-model="form.phone"
                                v-validate="'required|phonenumber'"
                                name="phone"
                                label="residential_canteen_address.phone"
                                :error-messages="errors.collect('phone')"
                                :data-vv-as="
                                    $t('residential_canteen_address.phone')
                                "
                            ></text-input>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
            <v-card color="grey lighten-5" flat>
                <v-card-title primary-title>
                    <h3 class="headline">
                        {{ $t('residential_canteen_address.address_details') }}
                    </h3>
                </v-card-title>
                <v-card-text>
                    <div class="row">
                        <div class="col-lg-12">
                            <address-autocomplete-input
                                v-model="form.fullAddress"
                                v-validate.immediate="'required'"
                                :label="
                                    $t('residential_canteen_address.address')
                                "
                                :latitude.sync="form.latitude"
                                :longitude.sync="form.longitude"
                                :country.sync="form.country"
                                :country-code.sync="form.countryCode"
                                :town.sync="form.town"
                                :zip-code.sync="form.zipCode"
                                :street.sync="form.street"
                                :house-number.sync="form.houseNumber"
                                name="fullAddresss"
                                :data-vv-as="
                                    $t('residential_canteen_address.address')
                                "
                                :error-messages="errors.collect('fullAddress')"
                            ></address-autocomplete-input>

                            <address-map-input
                                v-model="form.fullAddress"
                                style="height: 200px"
                                name="addressMap"
                                :draggable="true"
                            ></address-map-input>
                        </div>
                        <div class="col-lg-12">
                            <!-- residential canteen address sub address -->
                            <text-input
                                v-model="form.subAddress"
                                v-validate="'required|min:1|max:100|space'"
                                name="subAddress"
                                label="residential_canteen_address.sub_address"
                                :error-messages="errors.collect('subAddress')"
                                :data-vv-as="
                                    $t(
                                        'residential_canteen_address.sub_address'
                                    )
                                "
                            ></text-input>

                            <!-- residential canteen address comment -->
                            <text-input
                                v-model="form.comment"
                                v-validate="'required|min:1|max:100|space'"
                                name="comment"
                                label="residential_canteen_address.comment"
                                :error-messages="errors.collect('comment')"
                                :data-vv-as="
                                    $t('residential_canteen_address.comment')
                                "
                            ></text-input>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </base-form>
</template>

<script>
import routeType from '@/router/routeType'
import FormMixin from '@/components/mixins/FormMixin'
import AddressMapInput from '@/components/form/Inputs/google/AddressMapInput'

export default {
    components: {
        AddressMapInput,
    },
    mixins: [FormMixin],
    data() {
        return {
            form: {
                name: '',
            },
            entity: 'Residential Canteen address',
            editRoute: routeType.RESIDENTIAL_CANTEEN_ADDRESSES_EDIT,
            listRoute: routeType.RESIDENTIAL_CANTEEN_ADDRESSES,
        }
    },
    computed: {
        title() {
            return this.entityId
                ? this.$t('residential_canteen_address.edit_page_title', {
                      entityName: `${this.form?.name}`,
                  })
                : this.$t('residential_canteen_address.create_page_title')
        },
    },
    methods: {
        editRedirectParams: (data) => ({ entityId: data.id }),
    },
}
</script>
